export default __webpack_public_path__ + "static/media/event-audience.8aa087af.svg";